import { paths } from '../../common/constants/pathVariables.js';
import { useSearchParams } from '../../common/hooks/useSearchParams.js';
import { servicesMsg, t } from '../../common/i18n/index.js';
import { MobileSubscriptionLayout } from './MobileSubscriptionLayout.js';
import { getServiceNavigationItems } from './serviceSubscriptionLayoutUtils.js';
import type { CompanyInfoResponse } from '../../generated/api/companyInfoResponse.js';
import type { Subscription } from '../../generated/api/subscription.js';
import type { PropsWithChildren } from 'react';

export type ServiceSubscriptionLayoutProps = PropsWithChildren<{
  companyInfo: CompanyInfoResponse;
  subscription: Subscription;
}>;

const getHeadingBottom = (companyName?: string, editionName?: string) =>
  [companyName, editionName].filter(Boolean).join(' | ');

export const ServiceSubscriptionLayout = ({ children, companyInfo, subscription }: ServiceSubscriptionLayoutProps) => {
  const { mdmId } = useSearchParams<{ mdmId: string }>();
  if (!mdmId) {
    throw new Error('missing mdmId');
  }

  return (
    <MobileSubscriptionLayout
      subscription={subscription}
      headingTop=""
      heading={subscription.subscriptionName ?? ''}
      headingBottom={getHeadingBottom(companyInfo.companyName, subscription.details?.softwareProduct?.editionName)}
      heroPicto="generic-service-filled"
      navigationItems={getServiceNavigationItems(subscription, mdmId)}
      categoryBreadcrumbAndPath={{ name: t.MBG9(servicesMsg), path: paths.PS_SERVICES }}
    >
      {children}
    </MobileSubscriptionLayout>
  );
};
